import { Injectable } from "@angular/core";
import { IUserBrandingRepository } from "./user-branding-repository";
import { StorageService } from "../services/storage.service";
import { BackofficeUserBrandingSettings } from "./user-branding";

@Injectable()
export class UserBrandingService {
  constructor(
    private _userBrandingRepository: IUserBrandingRepository,
    private _storageService: StorageService,
  ) {}

  async getUserBrandingSettings(): Promise<BackofficeUserBrandingSettings> {
    const savedUserBrandingSettings = localStorage.getItem(
      "userBrandingSettings_backoffice",
    );
    if (savedUserBrandingSettings) {
      return Promise.resolve(
        BackofficeUserBrandingSettings.FromRawObject(
          JSON.parse(savedUserBrandingSettings),
        ),
      );
    }

    const result = await this._userBrandingRepository.getBackofficeUserBrandingSettingForCurrentDomain(
      window.location.hostname,
    );
    localStorage.setItem(
      "userBrandingSettings_backoffice",
      JSON.stringify(result),
    );

    return Promise.resolve(result);
  }
}
